import React, { useState } from "react";

// Material UI components
import { makeStyles } from "@mui/styles";
import { Grid } from "@mui/material";

// Core Components
import MDCModal from "../../../core/MDCModal";
import MDCButton from "../../../core/MDCButton";

// Assets
import carLogo from "../../../../assets/images/my_digital_car.svg";
import NewsAndUpdatesDetailView from "./NewsAndUpdatesDetailView";
import { useSelector } from "react-redux";

// utils
import {
  getFormattedDate,
  truncatedTextByLength,
} from "../../../../helpers/utils";

const useStyles = makeStyles((theme) => ({
  headerCss: {
    padding: "2rem",
    alignItems: "center",
  },
  headerColor: { color: theme.palette.MDCColors.black },
  newAndUpdateDetailSection: {
    background: theme.palette.MDCColors.cardBackgroundColor,
    padding: ".75rem",
    marginBottom: "1rem",
  },
  textColor: {
    color: theme.palette.MDCColors.textColor,
    fontSize: "0.875rem",
  },
}));

const NewsAndUpdatesOverviewPopup = ({ show, handleClose }) => {
  const newAndUpdatesListData = useSelector(
    (state) => state.finWhiteListReducer?.newAndUpdatesListData
  );

  const [showNewAndUpdateDetailView, setShowNewAndUpdateDetailView] =
    useState(false);
  const [newAndUpdateDetails, setNewAndUpdateDetails] = useState({});

  const { headerCss, headerColor, newAndUpdateDetailSection, textColor } =
    useStyles();

  const [messages] = useState(newAndUpdatesListData || []);

  const handleNewAndUpdateDetialClose = () => {
    setShowNewAndUpdateDetailView(false);
    setNewAndUpdateDetails({});
  };

  const getModalHeader = () => {
    return (
      <Grid container className={headerCss}>
        <Grid item xs={7} className={headerColor}>
          <h4>News & Updates</h4>
        </Grid>
        <Grid item xs={5}>
          <img alt="My Digital Car" src={carLogo} width={"95%"} />
        </Grid>
      </Grid>
    );
  };

  const getModalBody = () => {
    return (
      <Grid container padding="2rem" flexDirection="column">
        <Grid className={"newAndUpdateSection"}>
          {messages.length > 0 &&
            messages?.map((messageDetails, index) => (
              <div key={index} className={newAndUpdateDetailSection}>
                <h5>{messageDetails?.subject}</h5>
                <p className={textColor}>
                  {getFormattedDate(messageDetails?.updateDate, "DD MMMM YYYY")}
                </p>
                <p className={textColor}>
                  {truncatedTextByLength(messageDetails?.summary)}
                </p>

                <MDCButton
                  variant="outlined"
                  label={"Mehr Lesen"}
                  onClick={() => {
                    // Show new details view popup
                    setShowNewAndUpdateDetailView(true);
                    setNewAndUpdateDetails(messageDetails);
                  }}
                />
              </div>
            ))}
        </Grid>
      </Grid>
    );
  };

  const getModalFooter = () => {
    return (
      <Grid container padding="2rem" alignItems="center" flexDirection="column">
        <Grid container display={"flex"} justifyContent={"flex-end"}>
          <MDCButton
            variant="outlined"
            label={"Schließen"}
            onClick={() => {
              handleClose();
              sessionStorage.setItem("closeNewAndUpdatePopup", false);
            }}
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <div>
      <MDCModal
        open={show}
        title={getModalHeader()}
        body={getModalBody()}
        footer={getModalFooter()}
        size="sm"
        isScroll
      />

      {showNewAndUpdateDetailView && (
        <NewsAndUpdatesDetailView
          show={showNewAndUpdateDetailView}
          handleClose={handleNewAndUpdateDetialClose}
          newsId={newAndUpdateDetails?.newsId}
          newAndUpdateDetailView={newAndUpdateDetails}
        />
      )}
    </div>
  );
};

export default NewsAndUpdatesOverviewPopup;
